export default __webpack_public_path__ + "static/media/emergency.c9a2e8ea.png";